// extracted by mini-css-extract-plugin
export default {"wrapper":"WideButton_wrapper__ETrPr","title":"WideButton_title__SMLrV"};